module.exports = __webpack_public_path__ + "img/nobunaga.c446827f.jpg";